import { render, staticRenderFns } from "./LangDisclaimer.vue?vue&type=template&id=20e2ab64&scoped=true&"
import script from "./LangDisclaimer.vue?vue&type=script&lang=js&"
export * from "./LangDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./LangDisclaimer.vue?vue&type=style&index=0&id=20e2ab64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2ab64",
  null
  
)

export default component.exports